<template>
  <section class="header-sec">
    <div class="header-page">
      <div class="flex-wrap">
        <div class="logo-wrap">
          <img src="/assets/images/logo.png">
        </div>
        <div class="header-account">{{ userName }}님, 안녕하세요.</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name :"HeaderPage",
  data(){
    return {
      userName : ""
    }
  },
  async created() {
    await this.loginInit()
  },
  methods : {
    async loginInit() {
      var setupUserModel = await this.authStore.setupUser()
      if (setupUserModel != undefined && setupUserModel != null) {
        this.isLogin = true
        this.loginModel = setupUserModel
        this.userName = setupUserModel.name;
      }
    },
  }
}
</script>
<style scoped>
.header-sec .header-page {
  max-width: 100vw;
  position: fixed;
  top: 0;
  z-index: 8;
  background-color: #fff;
  box-shadow: 0px 4px 40px rgba(39, 32, 120, 0.1);
  width:100%;
  border-bottom:1px solid #e1e1e1;
}
.header-sec .header-page .flex-wrap {
  width: 100%;
  align-items: center;
  padding: 22px 30px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.header-sec .header-page .flex-wrap .logo-wrap img {
  height: 35px;
}
.header-sec .header-page .header-account {
  text-align: right;
  font-size:16px;
}
</style>